import { render, staticRenderFns } from "./DetailEwaCompany.vue?vue&type=template&id=2fdb7450"
import script from "./DetailEwaCompany.vue?vue&type=script&lang=js"
export * from "./DetailEwaCompany.vue?vue&type=script&lang=js"
import style0 from "./DetailEwaCompany.vue?vue&type=style&index=0&id=2fdb7450&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports